import React, { createContext, useContext, useState ,useEffect} from "react";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(null); // { username, adminType, egg }
  useEffect(() => {
    const username = localStorage.getItem("userName");
    const adminType = localStorage.getItem("userType");
    const egg = localStorage.getItem("egg"); 
  
    if (username && adminType) {
      setUserInfo({ username, adminType, egg });
    }
  }, []);
  return (
    <UserContext.Provider value={{ userInfo, setUserInfo }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);